import GlobalApp from '@/GlobalApp'
export default {
	version: 0,
	config : GlobalApp.config,
	user:{
		uid : null,
		username : null,
		name : null,
		isLogin : false,
		currentRoute : '',
		vendorsCount : 0,
		wallet :{
			setbank:false,
			totalAmounts:0,
			sync:'',
			refresh : false,
			deploy :{},
		},
		class : 0,
		login_time : '',
		mobile : '',
		email : '',
		bank : {
			bank_name:'',
			bank_value:'',
			bank_account:'',
			bank_username:'',
		},
		is_cash_password : false,
		created_at : '',
		line: '',
		unread: 0,
		error:false,
		bank_atm:'',
		vip_bank:'',
	},
	web:{
		//此參數是放全域暫存用的，例ps電子有數百個遊戲，先暫存在參數裡
		bulletins:[],
		win:[],
		qt:[],
		ae:[],
		sa_slot:[],
		//ddfg:[],
		allbet_slot:[],
		//dg:[],
		ps: [],
		//wm: [],
		ttg: [],
		//og: [],
		rtg: [],
		f8: [],
		banklists:[],
	},
	datalist: [],

}



// WEBPACK FOOTER //
// ./src/store/state.js